import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../shadcn/components/ui/card';
import { Badge } from '../../../shadcn/components/ui/badge';
import { ArrowRight } from 'lucide-react';
import { HandoffFlowItem } from 'api-types';

interface HandoffFlowVisualizationProps {
  handoffFlow: HandoffFlowItem[];
  assistantChain: string[];
}

export const HandoffFlowVisualization: React.FC<HandoffFlowVisualizationProps> = ({
  handoffFlow,
  assistantChain,
}) => {
  const getAssistantShortName = (name: string) => {
    if (name.includes('Router')) return 'Router';
    if (name.includes('SS Expert')) return 'SS Expert';
    if (name.includes('SL Expert')) return 'SL/SWV Expert';
    if (name.includes('GTV')) return 'GTV Expert';
    if (name.includes('General')) return 'General Expert';
    if (name.includes('Contact')) return 'Contact';
    return name;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Handoff Flow</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Visual Chain */}
        <div className="flex items-center gap-2 flex-wrap mb-6">
          {assistantChain.map((assistant, index) => (
            <React.Fragment key={index}>
              <Badge
                variant="outline"
                className="px-3 py-1 text-sm font-medium bg-blue-50 border-blue-200"
              >
                {getAssistantShortName(assistant)}
              </Badge>
              {index < assistantChain.length - 1 && (
                <ArrowRight className="h-4 w-4 text-gray-400" />
              )}
            </React.Fragment>
          ))}
        </div>

        {handoffFlow.length === 0 && (
          <p className="text-sm text-gray-500">No handoffs occurred during this call.</p>
        )}
      </CardContent>
    </Card>
  );
};
